import React, { useMemo, useState } from 'react';
import styles from './LoginWitSSOPage.module.less';
import PiplLogo from '../../../../static/img/pipl_logo.svg';
import AppConfig from '../../Config/AppConfig';

const LoginWithSSOPage = () => {
  const [email, setEmail] = useState('');

  const searchParams = new URLSearchParams(window.location.search);

  const nextString = searchParams.get('next');
  if (nextString) {
    searchParams.delete('next');
  }

  const buttonDisabled = !email;

  const link = useMemo(() => {
    const params = new URLSearchParams();

    params.set('email', email);

    if (nextString) {
      params.set('next', nextString);
    }

    for (const [key, value] of searchParams.entries()) {
      params.set(key, value);
    }

    return `/${AppConfig.ACCOUNTS_PREFIX}oidc/authenticate/?${params.toString()}`;
  }, [email, nextString, searchParams]);

  return (
    <div className={styles.container}>
      <img src={PiplLogo} alt="" />
      <div className={styles.header}>Organization Login</div>
      <form>
        <label className={styles.label} htmlFor="#id_email">
          <input
            className={styles.emailInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="id_email"
            name="email"
            placeholder="Enter email"
            autoComplete="email"
            type="text"
          />
        </label>

        <a
          className={[styles.loginButton, buttonDisabled ? styles.disabled : null].join(' ')}
          href={link}
          type="submit"
        >
          Login
        </a>
      </form>
      <footer className={styles.footer}>
        <div className={styles.wrapper}>
          <ul className="list-inline centered" id="js-light-footer">
            <li>
              <a href="https://pipl.com/product-tos/">Terms</a>
            </li>
            <li>|</li>
            <li>
              <a href="https://pipl.com/privacy/">Privacy</a>
            </li>
            <li>|</li>
            <li>
              <a href="https://pipl.com/customer-support">Contact</a>
            </li>
            <li>|</li>
            <li>
              <p className="copyright">&copy; 2006-{new Date().getFullYear()} pipl</p>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default LoginWithSSOPage;
